import { environment } from './../../environments/environment';
import { Explotacion } from './../entities/explotacion.entity';
import { Contacto } from './../entities/contacto.entity';
import { Component, OnInit } from '@angular/core';
import { UserService } from '../services/user.service';
import { SessionService } from '../services/session.service';
import { Router } from '@angular/router';
import { UsuarioOnline } from '../entities/UsuarioOnline.entity';
import { Contrato } from '../entities/contrato.entity';
import { validate, ValidationError } from 'class-validator';

@Component({
    selector: 'app-contact',
    templateUrl: './contact.component.html'
})
export class ContactComponent implements OnInit {

    public name: string;
    public email: string;
    public asunto: string;
    public consulta: string;
    public politicas: Boolean;

    public asuntoInputError: Boolean;
    public consultaInputError: Boolean;
    public politicasInputError: Boolean;

    public contacto: Contacto;
    public usuario: UsuarioOnline;

    public messageCabecera: string;
    public typeException: number;
    public messageComplet: string;

    public datosExplotacion: Explotacion;
    public avisoEmail: string;
    public condicionesEnvio: string;
    public horario: string;
    public ubicacionOficina: string;
    public parametro: any;
    public id: number;
    public direccionSuministro: string;
    public telefonoexplotacion: string;
    public telefonoexplotacion2: string;
    public pie: string;

    constructor(private userService: UserService, private sessionService: SessionService, private router: Router) { }

    ngOnInit() {
        this.pie = environment.pie;
        this.clearInputErrors();
        this.politicas = false;
        this.avisoEmail = 'Atención!!! La respuesta a su solicitud puede recibirla en la carpeta de correo no deseado.' +
            'En el caso de cuentas de correo de Hotmail, vemos necesario añadir previamente a sus contactos la cuenta ' +
        this.sessionService.datosExplotacion.Email + ' para asegurarse de que recibirá nuestros correos.';
      this.condicionesEnvio = this.sessionService.datosExplotacion.PoliticaEnvio;
        this.horario = this.sessionService.datosExplotacion.Horario;
        /* this.telefonoexplotacion = (this.sessionService.datosExplotacion.Contacto === null) ? ''
            : this.sessionService.datosExplotacion.Contacto.substring(2, (this.sessionService.datosExplotacion.Contacto.length - 1)
        ); */
        if (this.sessionService.datosExplotacion && this.sessionService.datosExplotacion.Contacto) {
          const TelsArray = this.sessionService.datosExplotacion.Contacto.split('-');
          this.telefonoexplotacion = TelsArray[0];
          this.telefonoexplotacion2 = TelsArray[1];
          this.ubicacionOficina = this.sessionService.datosExplotacion.Domicilio +
            ' (' + this.sessionService.datosExplotacion.Contacto.trim().replace('-', ' - ') + ')';
        } else {
            this.ubicacionOficina = this.sessionService.datosExplotacion.Domicilio;
        }
        this.usuario = this.sessionService.usuario;
        this.contacto = new Contacto();
        this.contacto.UsuarioOnline = new UsuarioOnline();
        this.name = this.sessionService.nombre;
        this.email = this.sessionService.email;
        this.usuario.Nombre = this.name;
        this.usuario.EMail = this.email;
        this.usuario.Explotacion = this.sessionService.explotacion;
        this.contacto.UsuarioOnline = this.usuario;
        this.contacto.ContratoEnUso = this.sessionService.contratoSelected.Codigo.toString();
        this.direccionSuministro = this.sessionService.contratoSelected.InmuebleBO.Direccion;
    }

    public enviar() {
        this.clearInputErrors();
        this.contacto = new Contacto();
        this.contacto.Asunto = this.asunto;
        this.contacto.Cuerpo = this.consulta;
        this.contacto.ContratoEnUso = this.sessionService.contratoSelected.Codigo.toString();
        this.usuario = this.sessionService.usuario;
        this.usuario.Nombre = this.name;
        this.usuario.EMail = this.email;
        this.usuario.Explotacion = this.sessionService.explotacion;
        this.contacto.UsuarioOnline = this.usuario;
        this.contacto.UsuarioOnline = this.usuario;
        validate(this.contacto).then(resultado => {
            if (resultado.length > 1 || !this.politicas) {
                this.showErrors(resultado);
            } else {
              if (document.getElementById('top') !== null)
                document.getElementById('top').scrollIntoView();
                this.userService.contacto(this.sessionService.explotacion, this.contacto).subscribe(
                    response => this.contactoOnSuccess(response),
                    response => this.contactoOnError(response)
                );
            }
        }
        );
    }

    public contactoOnSuccess(response) {
        this.messageCabecera = 'Mensaje enviado';
        this.typeException = 2;
        this.messageComplet = 'El mensaje se ha enviado correctamente. En breve recibiras una repuesta.';
        this.asunto = '';
        this.consulta = '';
    }

    public contactoOnError(response) {
        this.messageCabecera = 'Mensaje no enviado';
        this.typeException = 1;
        this.messageComplet = 'El mensaje no se ha enviado correctamente. Intentelo de nuevo en unos minutos o llámenos';
    }

    public recibirContrato(event): void {
        const contratoSelect: Contrato = event.contratoSeleccionado;
        this.direccionSuministro = contratoSelect.InmuebleBO.Direccion;
        this.clearInputErrors();
    }

    public showErrors(resultado: ValidationError[]) {
        for (const item of resultado) {
            switch (item.property) {
                case 'Asunto':
                    this.asuntoInputError = true;
                    break;
                case 'Cuerpo':
                    this.consultaInputError = true;
                    break;
            }
        }
        if (!this.politicas) {
            this.politicasInputError = true;
        }
    }

    public clearInputErrors() {
        this.asuntoInputError = false;
        this.consultaInputError = false;
        this.politicasInputError = false;
        this.messageCabecera = '';
        this.messageComplet = '';
        this.typeException = -1;
    }

}



// WEBPACK FOOTER //
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/app/home/contact.component.ts